import React from "react";
import { Link } from "react-router-dom";
import "./Bar.css";

const barItems = [
    {
        id: 1,
        title: "Online Pooja Booking",
        action: "Book Now",
        image: "./images/booking.png",
        link: "https://spst.suvidham.in/",
        external: true,
    },
    {
        id: 2,
        title: "Temple Timing",
        action: "View",
        image: "./images/darshan-timing.png",
        link: "timing",
        external: false,
    },
    {
        id: 3,
        title: "Latest Updates",
        action: "View",
        image: "./images/attraction.png",
        link: "pageupdates",
        external: false,
    },
    {
        id: 4,
        title: "Tenders",
        action: "View",
        image: "./images/accommodation.png",
        link: "NewsEvents",
        external: false,
    },
];

function Bar() {

    const renderItem = (item, index) => {

        const content = (
            <article
                className="bar-service-card"
                style={{
                    "--bar-delay": `${index * 0.12}s`,
                }}
            >

                {/* Image */}

                <div className="bar-service-image">

                    <img
                        src={item.image}
                        alt={item.title}
                    />

                </div>


                {/* Content */}

                <div className="bar-service-content">

                    <h3>
                        {item.title}
                    </h3>

                    <span>
                        {item.action}
                    </span>

                </div>


                {/* Arrow */}

                <div className="bar-service-arrow">

                    <i className="fa fa-arrow-right"></i>

                </div>

            </article>
        );


        if (item.external) {

            return (
                <a
                    key={item.id}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bar-service-link"
                >
                    {content}
                </a>
            );

        }


        return (
            <Link
                key={item.id}
                to={item.link}
                className="bar-service-link"
                onClick={() =>
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    })
                }
            >
                {content}
            </Link>
        );
    };


    return (

        <section className="temple-service-bar">

            <div className="bar-inner">

                {barItems.map(renderItem)}

            </div>

        </section>

    );
}

export default Bar;